import { BusyIndicator, checkCookieIsSet } from '@fctg-corporate/smartscript-core';
import type OktaAuth from '@okta/okta-auth-js';
import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { H3Alert } from '../components/LoginAlerts';
import { checkTokenValidity } from '../lib/utils';

export type PageProps = {
	tokenName: string,
	scopes: string[] | undefined,
	oktaAuth: OktaAuth
	path: string,
};

const Page: FC<PageProps> = ({ oktaAuth, tokenName, path }) => {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const location = useLocation();

	useEffect(() => {
		(async () => {
			const tokenIsValid = await checkTokenValidity(oktaAuth, tokenName);
			const cookieIsSet = checkCookieIsSet(tokenName);

			if (!tokenIsValid || !cookieIsSet) {
				if (oktaAuth.transactionManager.exists()) {
					await oktaAuth.transactionManager.clear();
				}

				await oktaAuth.signInWithRedirect({ redirectUri: `${window.location.origin}${path}/callback` });

				return;
			}

			setLoading(false);

			navigate(`${path}/callback`);
		})();
	}, [oktaAuth, tokenName, location.pathname, path, navigate]);

	if (loading) {
		return <BusyIndicator label={`Authenticating to ${path}...`}/>;
	}

	return (
		<H3Alert severity="success">
			{`You are now authenticated to ${path} with token named: ${tokenName}`}
		</H3Alert>
	);
};

export default Page;
